import { render } from "./GreetingHeader.vue?vue&type=template&id=97de11ce"
import script from "./GreetingHeader.vue?vue&type=script&lang=js"
export * from "./GreetingHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__